// extracted by mini-css-extract-plugin
export default {"swiping":"sPGm9cLw","title":"XFmiMTuP","wrap":"c7zyMqmA","left":"KK9HyKdA","right":"xKO2ChhO"};